import React, { useContext } from 'react';
import Box from 'atomic/box';
import classNames from 'classnames';
import WidgetImageTextProps from './widget-image-text.props';

import './widget-image-text.scss';
import SrcSet from '../../../components/src-set/src-set';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

const WidgetImageText: React.FC<WidgetImageTextProps> = props => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';

    return (
        <div className="w-image-text">
            <Box className="w-image-text-box">
                {props.data.modifiedImg && (
                    <div
                        className={classNames({
                            'w-image-text-box-image': true,
                            [`w-image-text--${props.data.imagePosition}`]: true
                        })}
                    >
                        <SrcSet
                            images={props.data.modifiedImg}
                            alt={props.data.alt?.trim()}
                            isMobile={isMobile}
                        />
                    </div>
                )}
                <div dangerouslySetInnerHTML={{ __html: props.data.html }} />
            </Box>
        </div>
    );
};

export default WidgetImageText;
